import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { UntypedFormGroup, FormControl, Validators, FormGroup } from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
    selector: "deposit-ticket",
    templateUrl: "./deposit-ticket.component.html",
    styleUrls: ["./deposit-ticket.component.scss"],
    standalone: false
})
export class DepositTicketComponent implements OnInit,OnChanges {
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;
  @Input() category: string;
  constructor() {}


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }  }

  ngOnInit(): void {
   
  }
  initiateForm(){
    this.form.addControl("swift", new FormControl("", [Validators.required]));
    this.form.addControl("message", new FormControl("", [Validators.required]));
  }
  onFileSelect(file:FileInput) {
    this.form.get("swift").setValue({
      name: file.file.name,
      content: file.base64,
    });
  }
  get message() {
    return this.form.get("message");
  }

  get swift() {
    return this.form.get("swift");
  }
  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  onFileRemove() {
    this.form.get("swift").reset();
  }


}
